import styled from "styled-components";
import { theme } from "uikit";

/**
 * Card container for the blocks of the section.
 */
const Panel = styled.div<{ grow?: boolean }>`
	display: flex;
	flex-direction: column;
	gap: 12px;

	min-width: 0;
	max-width: 100%;
	flex-shrink: 0;
	padding: 16px;

	background: ${theme.colors.white};
	border: 1px solid ${theme.colors.color_border_basic};
	border-radius: ${theme.borderRadius.m};

	${({ grow }) => (grow ? "flex: 1; min-height: 0;" : "")}
`;

export const PanelTitle = styled.div`
	font-family: Lato;
	font-size: 16px;
	font-weight: 600;
	color: ${theme.colors.primary};
`;

export const PanelHint = styled.div`
	font-family: Lato;
	font-size: 13px;
	color: ${theme.colors.secondary};
`;

export const EmptyState = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;

	padding: 24px;

	font-family: Lato;
	font-size: 14px;
	color: ${theme.colors.secondary};
`;

export default Panel;
